<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header class="common-header" title="付款">
                <mt-button icon="back" slot="left" @click="goBack"></mt-button>
            </mt-header>
        </div>
        <div v-if="pay_info">
            <div class="top-wrapper">
                <div class="row-wrapper title-wrapper">
                    <i class="icon iconfont">&#xe6d2;</i>
                    <label class="title">订单提交成功，请选择付款方式</label>
                </div>
                <div class="row-wrapper subtitle-wrapper">
                    <label class="subtitle">合计：</label>
                    <label class="price">￥ {{pay_info.pay_amount}}</label>
                </div>
            </div>

            <div class="item-wrapper" v-on:click="payType(item.payment_code)" v-for="(item,index) in payment_list" :key="index">
                <div class="item-left-wrapper">
                    <i class="icon"></i>
                    <label class="item-title">{{item.payment_name}}</label>
                </div>
                <div class="item-right-wrapper">
                    <i class="item-select iconfont" v-if="payment_info.payment_code == item.payment_code">&#xe69d;</i>
                </div>
            </div>
        </div>
        <div class="warp-img" v-if="showimg" @click="closeImg">
             <img :src="srcimg" style="width:200px;height:200px;" alt="">
        </div>
       
        <mt-button class="ds-button-large" type="primary" v-on:click="submit">立即付款</mt-button>
    </div>
</template>

<script>
    import { getOrderpayInfo,getOrderpayInfo1 } from '../../../api/memberBuy'
    import { getVrOrderpayInfo } from '../../../api/memberVrBuy'
    import { mapState } from 'vuex'
    import { pay, getPaymentList, doH5Pay,doH5Pay1,getQrcode, getOrderState,payNew } from '../../../api/memberPayment'
    import { getRechargeInfo } from '../../../api/memberRecharge'
    import { Toast, MessageBox } from 'mint-ui'
    import { loadScript } from '../../../util/common'
    export default {
        name: 'pay',
        data () {
            return {
                uniapp: 0,
                pay_sn: this.$route.query.pay_sn ? this.$route.query.pay_sn : '',
                pay_type: this.$route.query.pay_type ? this.$route.query.pay_type : '',
                // 订单支付显示的数据
                pay_info: null,
                // 提交支付需要用到的数据
                payment_info: {
                    password: '', // 支付密码
                    rcb_pay: 0, // 是否使用充值卡进行支付
                    pd_pay: 0, // 是否使用预存款进行支付
                    payment_code: 'alipay_h5' // 支付方式

                },
                payment_list: [],
                showNotice: 0,
                notice: this.$route.query.notice,
                ifLoaded: false,
                isPC:false,
                srcimg:'',
                showimg:false,
                timers:null, // 定时器
				is_virtual:null,//是否为虚拟商品
            }
        },
        computed: {
            ...mapState({
                token: state => state.member.token

            })
        },
        created: function () {
            // doH5Pay(this.pay_sn).then(res => {
            //  let regex = /"([^"]*)"/g;
            //  let url = regex.exec(res);
            //  console.log(url[1])
            // window.location.href = url[1]
            // })
				this.is_virtual = this.$route.query.is_virtual
				if(this.is_virtual!==null&&this.is_virtual!==''&&this.is_virtual!==undefined&&this.is_virtual!=='undefined'){
					localStorage.setItem('is_virtual',this.is_virtual)
				}
            let _this = this
            loadScript('uniapp', 'https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js', function () {
                uni.getEnv(function (res) {
                    _this.ifLoaded = true
                    if (res.plus) {
                        _this.uniapp = 1
                    }
                })
            })

            this.isPC = this.isWeChat()
            console.log( this.isPC,123123)

        },
		mounted() {
			this.getMemberPayInfo()
		},
        watch: {
            showNotice: function (val) {
                if (val && this.notice) {
                    MessageBox.confirm('如果您已完成支付，请点击“完成付款”按钮，如果您未完成支付，请点击“重新支付”重新发起支付', '确认支付是否完成', { cancelButtonText: '重新支付', confirmButtonText: '完成付款' }).then(action => {
                        this.goNext()
                    })
                }
            },
            ifLoaded: function (val) {
                if (val) {
                    this.getPaymentList()
                }
            }
        },
        methods: {
        closeImg() {
            clearInterval(this.timers)
            this.showimg = false
        },

        isWeChat(){
             var system = { 
                    win: false, 
                    mac: false, 
                    xll: false, 
                    ipad: false
                    }; 
                    //检测平台 
                    var p = navigator.platform; 
                    system.win = p.indexOf("Win") == 0; 
                    system.mac = p.indexOf("Mac") == 0; 
                    system.x11 = (p == "X11") || (p.indexOf("Linux") == 0); 
                    system.ipad = (navigator.userAgent.match(/iPad/i) != null) ? true : false; 
                    //跳转语句，如果是手机访问就自动跳转到wap.baidu.com页面 
                    if (system.win || system.mac || system.xll || system.ipad) { 
                       return true
                    } else { 
                    var ua = navigator.userAgent.toLowerCase(); 
                        if(ua.match(/MicroMessenger/i)=="micromessenger") { 
                            // alert("在手机端微信上打开的"); 
                            return false
                        } else { 
                            // alert("在手机上非微信上打开的"); 
                            return true
                        } 
                    }
            // var userAgentInfo = navigator.userAgent;  
            // console.log(userAgentInfo,12312)
            // var Agents = ['Android', 'iPhone',  
            //     'SymbianOS', 'Windows Phone',  
            //     'iPad', 'iPod'  
            // ];  
            // var flag = true;  
            // for (var i = 0; i < Agents.length; i++) {  
            //     if (userAgentInfo.indexOf(Agents[i]) != -1) {  
            //         flag = false;  
            //         break;  
            //     }  
            // }  
            // return flag;  
        },
            goBack () {
                if (this.notice) {
                    this.$router.go(-2)
                } else {
                    this.$router.go(-1)
                }
            },
            goNext () {
                if (this.$route.query.pay_type === 'pay_new') {
                    this.$router.push({ name: 'MemberOrderList' })
                } else if (this.$route.query.pay_type === 'vr_pay_new') {
                    this.$router.push({ name: 'MemberVrOrderList' })
                } else if (this.$route.query.pay_type === 'pd_pay') {
                    this.$router.push({ name: 'MemberRechargeList' })
                }
            },
            payType (code) {
				console.log(code,'code');
                this.payment_info.payment_code = code
            },
            getPaymentList () {
                let _this = this

                getPaymentList(this.uniapp).then(res => {
                    this.payment_list = res.result.payment_list
                    if (this.payment_list.length&&this.isPC) {
                            let obj =  this.payment_list.find(item => {
                                if (item.payment_code === 'wxpay_native') {
                                    return item
                                }
                            })
                            if (obj&&obj.payment_code) {
                                this.payment_info.payment_code = 'wxpay_native'
                            } else {
                                this.payment_info.payment_code = this.payment_list[0].payment_code
                            }    
                      
                    } else if(this.payment_list.length&&!this.isPC){
                        this.payment_info.payment_code = this.payment_list[0].payment_code
                    }
                    loadScript('weixin', 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js', function () {
                        wx.miniProgram.getEnv(function (res) {
                            for (var i in _this.payment_list) {
                                if (res.miniprogram) {
                                    if (_this.payment_list[i].payment_code == 'wxpay_jsapi') {
                                        _this.payment_list.splice(i, 1)
                                        break
                                    }
                                } else {
                                    if (_this.payment_list[i].payment_code == 'wxpay_minipro') {
                                        _this.payment_list.splice(i, 1)
                                        break
                                    }
                                }
                            }
                        })
                    })
                }).catch(function (error) {
                    Toast(error.message)
                })
            },
            getMemberPayInfo () {
				if(this.$route.query.is_virtual==1){
					getOrderpayInfo1(
					    this.pay_sn
					).then((res) => {
					    if (res.code === 10000) {
					        this.pay_info = res.result.pay_info
					        console.log(res.result.pay_info.pay_amount,'res.result.pay_info.pay_amount')
					        let price = Number(res.result.pay_info.pay_amount)
					        this.pay_info.pay_amount = price < 0 ? '0.00' : price.toFixed(2)
					    }
					    this.showNotice = 1
					}).catch(function (error) {
					    if (error.code === 12001) { // 订单已经支付
					        _this.goNext()
					    } else {
					        Toast(error.message)
					    }
					})
				}else{
					if (this.$route.query.pay_type === 'pay_new') {
					    let _this = this
					    getOrderpayInfo(
					        this.pay_sn
					    ).then((res) => {
					        if (res.code === 10000) {
					            this.pay_info = res.result.pay_info
					            console.log(res.result.pay_info.pay_amount,'res.result.pay_info.pay_amount')
					            let price = Number(res.result.pay_info.pay_amount)
					            this.pay_info.pay_amount = price < 0 ? '0.00' : price.toFixed(2)
					        }
					        this.showNotice = 1
					    }).catch(function (error) {
					        if (error.code === 12001) { // 订单已经支付
					            _this.goNext()
					        } else {
					            Toast(error.message)
					        }
					    })
						console.log('111111111');
					} else if (this.$route.query.pay_type === 'vr_pay_new') {
					    let _this = this
					    getVrOrderpayInfo(
					        this.pay_sn
					    ).then((res) => {
					        if (res.code === 10000) {
					            this.pay_info = res.result.pay_info
					        }
					        this.showNotice = 1
					    }).catch(function (error) {
					        if (error.code === 12001) { // 订单已经支付
					            _this.goNext()
					        } else {
					            Toast(error.message)
					        }
					    })
					} else if (this.$route.query.pay_type === 'pd_pay') {
					    getRechargeInfo(
					        this.pay_sn
					    ).then((res) => {
					        if (res.code === 10000) {
					            this.pay_info = { pay_amount: res.result.pdinfo.pdr_amount }
					        }
					        this.showNotice = 1
					    }).catch(function (error) {
					        if (error.code === 12001) { // 订单已经支付
					            _this.goNext()
					        } else {
					            Toast(error.message)
					        }
					    })
					}
				}
                
            },
            submit () {
                var param = 'action=' + this.$route.query.pay_type + '&key=' + this.token + '&pay_sn=' + this.pay_sn + '&password=' + this.payment_info.password + '&rcb_pay=' + this.payment_info.rcb_pay + '&pd_pay=' + this.payment_info.pd_pay + '&payment_code=' + this.payment_info.payment_code
				// let isGoods = localStorage.getItem('is_virtual')
                if (this.payment_info.payment_code == 'wxpay_minipro') {
                    wx.miniProgram.redirectTo({ url: '../pay/pay?' + param })
                    return
                }
                if (this.isPC&&this.payment_info.payment_code  == 'wxpay_native') {
					console.log('222')
                  payNew({
                       payment_code:'wxpay_native',
                       pay_sn: this.pay_sn,
                       Key: this.token
                   }).then(res => {
                     this.srcimg =  env.SITE_URL + '/api/Index/qrcode?data=' + res.result
                    //  alert('doH5Pay')
                     this.showimg = true
                     this.timers = setInterval(() => {
                        getOrderState(this.pay_sn).then(res_query => {
                           if(res_query.code === 10000) {
                                if(res_query.result.order_state == 20) {
                                      Toast('支付成功')
                                     this.showimg = false
                                    this.$router.push({
                                        name:'MemberOrderList'
                                    })
                                    clearInterval(this.timers)
                                } 
                           }
                        });
                     },3000)
                    //  getQrcode(res).then(ress => {
                    //      console.log(ress,'ress')
                    //  })
                  }).catch(function (error) {
                       Toast(error.message)
                  })
                } else { 
					if(this.$route.query.is_virtual!=0){
						doH5Pay1(this.pay_sn, this.payment_info.payment_code, this.token).then(res => {
						    if (res.code) {
						        
						    if (res.code === 10000) {
						        let that = this;
						        if ( that.payment_info.payment_code == 'wxpay_app' || that.payment_info.payment_code == 'alipay_app') {
						            let channel;
						            
						            mui.plusReady(function() {
						                // 获取支付通道
						                plus.payment.getChannels(function(channels){
						                    for (let i = 0; i < channels.length; i++) {
						                        if ((channels[i].id == 'wxpay' && that.payment_info.payment_code == 'wxpay_app') || 
						                            (channels[i].id == 'alipay' && that.payment_info.payment_code == 'alipay_app')) {
						                            channel = channels[i];
						                            break;
						                        }
						                    }
						                    
						                    // setTimeout(function() {
						                    //     mui.confirm('支付是否已完成？', '提示', ['支付遇到问题', '支付完成'], function(e) {
						                    //         if(e.index == 1) {
						                    //             getOrderState(this.pay_sn).then(res_query => {
						                    //                 alert(JSON.stringify(res_query))
						                    //             });
						                    //         } else {
						                    //             // 遇到问题
						                    
						                    //         }
						                    //     }, 'div')
						                    // }, 3000);
						            
						                    if (that.payment_info.payment_code == 'alipay_app') {
						                        plus.payment.request(channel, res.result, function(result) {
						                            // alert(JSON.stringify(result));
						                            that.$router.push({
						                                name:'MemberOrderList'
						                            })
						                        }, function(error) {
						                            mui.toast("支付失败:" + error.message);
						                        });
						            
						                    } else if (that.payment_info.payment_code == 'wxpay_app') {
						                        plus.payment.request(channel, res.result.content, function(result) {
													localStorage.removeItem('is_virtual')
						                            that.$router.push({
						                                name:'MemberOrderList'
						                            })
						                        }, function(error) {
						                            mui.toast("支付失败:" + error.message);
						                        });
						            
						                    }
						                },function(e){
						                    mui.toast("获取支付通道失败："+e.message);
						                });
						            })
						            return
						        }
						        // document.getElementsByTagName('head')[0].appendChild(res);
						        let regex = /"([^"]*)"/g;
						        let url = regex.exec(res);
						        if (this.payment_info.payment_code == 'wxpay_minipro') {
						            wx.miniProgram.redirectTo({ url: url })
						            return
						        }
						        // uni.redirectTo({ url: url[1] })
						        // alert(JSON.stringify(url))
						        window.location.href = url[1]
						    } else {
						        Toast(res.message)
						    }
						    } else {
						    document.write(res)
						    }
						    
						
						}).catch(function (error) {
						    if (error.message) {
						    Toast(error.message)
						    } else {
						    document.write(error)
						    }
						})
						return false
					}else{
						if (this.payment_info.payment_code === 'wxpay_h5') {
											  
											  console.log('22222222');
						   pay(
						      this.pay_sn, this.$route.query.pay_type, this.payment_info, this.token, this.uniapp
						  ).then((res) => {
												
						      if (res.code) {
						      if (res.code === 10000) {
													console.log('111111111111')
													// this.$router.push({
													//     name:'MemberOrderList'
													// })
						          this.goNext()
						      } else {
						          Toast(res.message)
						      }
						      } else {
						      document.write(res)
						      }
						  }).catch(function (error) {
						      if (error.message) {
						      Toast(error.message)
						      } else {
						      document.write(error)
						      }
						  })
						                  
						} else {
						  doH5Pay(this.pay_sn, this.payment_info.payment_code, this.token).then(res => {
						      if (res.code) {
						          
						      if (res.code === 10000) {
						          let that = this;
						          if ( that.payment_info.payment_code == 'wxpay_app' || that.payment_info.payment_code == 'alipay_app') {
						              let channel;
						              
						              mui.plusReady(function() {
						                  // 获取支付通道
						                  plus.payment.getChannels(function(channels){
						                      for (let i = 0; i < channels.length; i++) {
						                          if ((channels[i].id == 'wxpay' && that.payment_info.payment_code == 'wxpay_app') || 
						                              (channels[i].id == 'alipay' && that.payment_info.payment_code == 'alipay_app')) {
						                              channel = channels[i];
						                              break;
						                          }
						                      }
						                      
						                      // setTimeout(function() {
						                      //     mui.confirm('支付是否已完成？', '提示', ['支付遇到问题', '支付完成'], function(e) {
						                      //         if(e.index == 1) {
						                      //             getOrderState(this.pay_sn).then(res_query => {
						                      //                 alert(JSON.stringify(res_query))
						                      //             });
						                      //         } else {
						                      //             // 遇到问题
						                      
						                      //         }
						                      //     }, 'div')
						                      // }, 3000);
						              
						                      if (that.payment_info.payment_code == 'alipay_app') {
						                          plus.payment.request(channel, res.result, function(result) {
																		localStorage.removeItem('is_virtual')
						                              // alert(JSON.stringify(result));
						                              that.$router.push({
						                                  name:'MemberOrderList'
						                              })
						                          }, function(error) {
						                              mui.toast("支付失败:" + error.message);
						                          });
						              
						                      } else if (that.payment_info.payment_code == 'wxpay_app') {
						                          plus.payment.request(channel, res.result.content, function(result) {
																		localStorage.removeItem('is_virtual')
						                              that.$router.push({
						                                  name:'MemberOrderList'
						                              })
						                          }, function(error) {
						                              mui.toast("支付失败:" + error.message);
						                          });
						              
						                      }
						                  },function(e){
						                      mui.toast("获取支付通道失败："+e.message);
						                  });
						              })
						              return
						          }
                                  else if(that.payment_info.payment_code == 'unipayh5'){
                                      console.log("云闪付H5支付");
                                      window.location.href =res.result;//进行跳转
                                      return false;
                                  }
						          // document.getElementsByTagName('head')[0].appendChild(res);
						          let regex = /"([^"]*)"/g;
						          let url = regex.exec(res);
						          if (this.payment_info.payment_code == 'wxpay_minipro') {
						              wx.miniProgram.redirectTo({ url: url })
						              return
						          }
						          // uni.redirectTo({ url: url[1] })
						          // alert(JSON.stringify(url))
						          window.location.href = url[1]
						      } else {
						          Toast(res.message)
						      }
						      } else {
						      document.write(res)
						      }
						      
						  
						  }).catch(function (error) {
						      if (error.message) {
						      Toast(error.message)
						      } else {
						      document.write(error)
						      }
						  })
						}
					}
				 //  if (this.uniapp) {
				 //    // uni.redirectTo({ url: 'pay?' + param })
					// window.location.href = 'pay?' + param;
				 //    return
				 //  }
                   
				  // pay(
				  //   this.pay_sn, this.pay_type, this.payment_info, this.token, this.uniapp
				  // ).then((res) => {
				  //   if (res.code) {
				  //     if (res.code === 10000) {
				  //       this.goNext()
				  //     } else {
				  //       Toast(res.message)
				  //     }
				  //   } else {
				  //     document.write(res)
				  //   }
				  // }).catch(function (error) {
				  //   if (error.message) {
				  //     Toast(error.message)
				  //   } else {
				  //     document.write(error)
				  //   }
				  // })
                 
                    
                }
            }
        }
    }
</script>

<style scoped lang='scss'>
    .container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        background-color: $mainbgColor;
    }
    .top-wrapper {
        height: 6rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        background-color: #fff;
        margin-bottom: 0.75rem;
    }
    .row-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .title-wrapper {
        height: 3.2rem;
    }
    .subtitle-wrapper {
        height: 1.5rem;
        margin-top: 0.5rem;
    }
    .icon {
        width: 0.9rem;
        height: 0.9rem;
        margin-left: 0.8rem;
        margin-right: 0.5rem;
    }
    .title {
        font-size: 0.8rem;
        color: #3C3C3C;
    }
    .subtitle {
        font-size: 0.8rem;
        color: #4D4D4D;
        margin-left: 2.5rem;
    }
    .price {
        font-size: 0.8rem;
        color: $primaryColor;
    }
    .item-wrapper{
        height: 3.1rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        background-color: #fff;
        border-bottom: 1px solid $lineColor;
    }
    .item-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: stretch;
        background-color: #fff;
    }
    .item-left-wrapper {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .item-right-wrapper {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
    }
    .item-title {
        font-size: 0.8rem;
        color: #3C3C3C;
    }
    .item-subtitle {
        font-size: 0.8rem;
        color: #8C8C8C;
        margin-right:0.25rem;
        text-align: right;
    }
    .item-select {
        width: 0.8rem;
        height: 0.8rem;
        margin-right: 1.1rem;
    }
    .indicator {
        width: 0.7rem;
        height: 0.7rem;
        margin-left:0.25rem;
        margin-right: 0.8rem;
    }
    .action-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 2.5rem;
        margin-top: 2.25rem;
    }
    .warp-img {
        position: fixed;
        width:100vw;
        height:100vh;
        background: rgba(0,0,0,.5);
        z-index:1;
        display:flex;
        justify-content: center;
        align-items: center;
    }
</style>
